// import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import '@utils/i18n'
import App from '@/App';
// import reportWebVitals from '@utils/reportWebVitals';
import theme from '@/theme';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from "@mui/material/CssBaseline";
import { SnackbarProvider } from '@contexts/SnackbarContext';
import { DialogProvider } from '@/contexts/DialogContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <StrictMode> // Génère des erreurs avec BPMN.js
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <DialogProvider>
          <CssBaseline />
          <App />
        </DialogProvider>
      </SnackbarProvider>
    </ThemeProvider>
  // </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
